import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "../components/CheckoutForm"; // Create this next

const stripePromise = loadStripe(
  "pk_live_51QbN3nHkl0IIwdOG8FWwTj49vzNpKAMswCXdSfZo36gy66hhfBlwIVRczFM37Mq87g0GC99kYt1tWDs7OtNvb7fv00wdZ7UAQP"
); // Replace with your Stripe publishable key

const PaymentPage = () => {
  return (
    <Elements stripe={stripePromise}>
        <CheckoutForm />
    </Elements>
  );
};

export default PaymentPage;
